// extracted by mini-css-extract-plugin
export default {"breakpoint_tablet_max_width_1199":"1199px","newsLetterPromotion":"fas_newsLetterPromotion","visible":"fas_visible","absPositioned":"fas_absPositioned"};